const antiFraud = `<script>
(function(d, w, nav, sc) {
  function serialize(obj) {
    return Object.keys(obj)
      .map(function(key) {
        return [key, obj[key]].join('=');
      })
      .join('&');
  }
 
  function getCookie(name) {
    var matches = d.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return matches ? decodeURIComponent(matches[1]) : '';
  }
 
  function hit(referrer) {
    var s = w && w.sessionStorage ? w.sessionStorage : {};
    var query = {
      rnd: Math.random().toString(),
      u: encodeURIComponent(d.URL),
      r: encodeURIComponent(referrer || d.referrer)
    };
 
    try {
      var e = d.documentElement;
      query.uc = getCookie('staduid')||(Math.random().toString(16).substring(2, 15) + Math.random().toString(16).substring(2, 15) + Math.random().toString(16).substring(2, 15)).substring(0,32).toUpperCase();
      query.v = 4;
      query.w = w.top === w ? 1 : 0;
      query.h = d.hidden ? 1 : 0;
      query.gW = Math.max(e.clientWidth, w.innerWidth || 0);
      query.gH = Math.max(e.clientHeight, w.innerHeight || 0);
      query.gDH = Math.max(d.body.scrollHeight, e.scrollHeight, d.body.offsetHeight, e.offsetHeight, d.body.clientHeight, e.clientHeight);
      query.gDW = Math.max(d.body.scrollWidth, e.scrollWidth, d.body.offsetWidth, e.offsetWidth, d.body.clientWidth, e.clientWidth);
      query.sW = sc.width || 0;
      query.sH = sc.height || 0;
      query.ga = getCookie('_ga');
      query.dpr = w.devicePixelRatio || '';
      query.c = (function() {
        var conn = '';
        if (nav && nav.connection) {
          if (nav.connection.type) conn = nav.connection.type;
          else if (nav.connection.effectiveType) conn = 'eff:' + nav.connection.effectiveType;
        }
        return conn;
      })();
      query.t = s && s._tid ? s._tid : (s._tid = Date.now());
 
      if (w.performance) {
        if (w.performance.navigation) {
          query.rc = w.performance.navigation.redirectCount;
          query.tn = w.performance.navigation.type;
        }
 
        if (w.performance.timing) query.dc = (w.performance.timing.secureConnectionStart || w.performance.timing.fetchStart) - w.performance.timing.fetchStart;
      }
    } catch (e) {}
 
    var path = '//statad.ru/pixel.gif';
    var qs = serialize(query);
    new Image().src = [path, '?', qs].join('');
 
    var date = new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000);
    document.cookie = "staduid=" + query.u + "; path=/; expires=" + date.toUTCString();
  }
 
  hit();
 
  var url = w.location.href;
  var count = 0;
  var checkInterval = setInterval(function() {
    if (count >= 50) clearInterval(checkInterval);
    else if (url !== w.location.href) {
      hit(url);
      url = w.location.href;
      count++;
    }
  }, 1000);
})(document, window, navigator, screen);
</script>`;

const alfaPartners = url => `<script>
(function(d, w, nav, sc) {
  var isPixelSent = false;
  var utmSource = new URL(window.location.href).searchParams.get('utm_source');

  if(!utmSource || !utmSource.includes('alfapartners')) return;

  dataLayer.push({ event: 'alfapartners' });

  function serialize(obj) {
    return Object.keys(obj)
      .map(function(key) {
        return [key, obj[key]].join('=');
      })
      .join('&');
  }
 
  function getCookie(name) {
    var matches = d.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return matches ? decodeURIComponent(matches[1]) : '';
  }

  function createPixel(product = '') {
    if (isPixelSent) return;

    var query = {};
    var sessionStart = getCookie('gtm-session-start') || new Date().getTime();
    var cid = getCookie('_ym_uid');

    try {
      query.platform_id = getCookie('platformId') || getCookie('GTM_platformId') || 'alfasite';
      query.url = '${url}';
      query.clientid = getCookie('_ym_uid');
      query.sessionid = [sessionStart, cid].join('.');
      query.product = product;
    } catch (e) {}

    var path = 'https://alfapartners.alfabank.ru/pixel/click/';
    var qs = serialize(query);
    var img = new Image();
    img.src = [path, '?', qs].join('');
    img.style = 'position:absolute; left:-9999px;'

    isPixelSent = true;
  }

  function subscribeProduct(dlvalues) {
    if (!dlvalues.product) return;

    createPixel(dlvalues.product);
  }

  if (window.DATA_LAYER) { window.DATA_LAYER.subscribe(subscribeProduct) }

  window.onunload = function () { createPixel() };
})(document, window, navigator, screen);
</script>
`;

module.exports = {
    alfaPartners,
    antiFraud
};
